// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`MoneyLabel test Match con el snapshot 1`] = `<span class="money-label">$ </span>`;
